module.exports = __webpack_public_path__ + "static/img/bg_02.a0377cda.jpg";